function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Google__G__Logo",
  transform: "translate(0.05 0.018)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_186",
  "data-name": "Path 186",
  d: "M286.089,226.059a17.126,17.126,0,0,0-.252-2.959H272.1v5.608h7.867a6.741,6.741,0,0,1-2.911,4.426v3.639h4.693A14.224,14.224,0,0,0,286.089,226.059Z",
  transform: "translate(-257.586 -211.178)",
  fill: "#4285f4"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_187",
  "data-name": "Path 187",
  d: "M41.915,336.073a13.942,13.942,0,0,0,9.654-3.516l-4.693-3.639A8.833,8.833,0,0,1,33.743,324.3H28.9v3.751A14.566,14.566,0,0,0,41.915,336.073Z",
  transform: "translate(-27.401 -306.963)",
  fill: "#34a853"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_188",
  "data-name": "Path 188",
  d: "M6.337,159.328a8.723,8.723,0,0,1,0-5.576V150H1.5a14.576,14.576,0,0,0,0,13.079Z",
  transform: "translate(0 -141.99)",
  fill: "#fbbc04"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_189",
  "data-name": "Path 189",
  d: "M41.915,5.746A7.914,7.914,0,0,1,47.5,7.929L51.66,3.771A14,14,0,0,0,41.915-.017,14.561,14.561,0,0,0,28.9,8.01l4.838,3.751A8.711,8.711,0,0,1,41.915,5.746Z",
  transform: "translate(-27.401 0)",
  fill: "#ea4335"
}));

function SvgIcGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.552,
    height: 29.129,
    viewBox: "0 0 28.552 29.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoogleLogo);
export default ForwardRef;